export default "__VITE_ASSET__99ed9eee__"